<div class="locked-field" [attr.title]="tooltip || null" [attr.aria-readonly]="true">
  <svg class="locked-field__icon" width="14" height="14" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false">
    <rect x="5" y="11" width="14" height="9" rx="2"></rect>
    <path d="M8 11V8a4 4 0 0 1 8 0v3"></path>
  </svg>
  <span class="locked-field__value">{{ value }}</span>
</div>
